import {ErrorWithData} from '../../../../libs/shared/helpers/src/types/customErrors';
import {offlineDraftComments} from '../../../../srcCommon/services/offline/offlineDraftComments';
import {withTimeoutAsync} from '../../../helpers/asyncHelpers';
import {CommentModel} from '../../../models/api/commentModel';

/*
 * Client-side storage.
 */

const cacheTimeout = 15 * 1000;

export async function addCommentToCacheAsync(comment: CommentModel) {
  return withTimeoutAsync(
    () => offlineDraftComments.addAsync(comment),
    cacheTimeout,
    (elapsedWallTime) => {
      throw new ErrorWithData('Saving offline comment draft timed out', {
        elapsedWallTime,
        timeout: cacheTimeout,
      });
    },
  );
}

export async function removeCommentFromCacheAsync(comment: CommentModel) {
  return withTimeoutAsync(
    () => offlineDraftComments.removeAsync(comment),
    cacheTimeout,
    (elapsedWallTime) => {
      throw new ErrorWithData('Removing offline comment draft timed out', {
        elapsedWallTime,
        timeout: cacheTimeout,
      });
    },
  );
}
